import React from 'react';

import StyledTooltip from '../../General/Tooltip/StyledTooltip';
import RibbonButtonSize from './RibbonButtonSize';
import type { IRibbonBtnConfig } from './RibbonConfig';

import styles from './RibbonButton.module.scss';
import { selectedStateName } from '../../../Redux/SelectedStateSlice';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { upperCaseBegin } from '../../../utils/stringUtils';
import { GlobalVariables } from '../../../pdf/GlobalVariables';

export default (props: IRibbonBtnConfig) => {
    if (!props.config) {
        console.error(`Missing props.config: ${JSON.stringify(props)}`);
        return <></>;
    }

    const textOnly: boolean = props.size === RibbonButtonSize.TextOnly;
    const iconOnly: boolean =
        props.size === RibbonButtonSize.LargeIcon || props.size === RibbonButtonSize.SmallIcon;
    const isLargeIcon: boolean =
        props.size === RibbonButtonSize.LargeIcon ||
        props.size === RibbonButtonSize.LargeIconWithText;
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    const cssClasses: string[] = [styles.button];

    const currentState = useSelector(selectedStateName);

    if (isLargeIcon) {
        cssClasses.push(styles.buttonL);
    }

    const classNames = React.useMemo(() => {
        if (props.config && props.config.StateName && props.config.StateName === currentState) {
            cssClasses.push(styles.selectedButton);
        }
        return cssClasses.join(' ');
    }, [currentState]);

    const tooltipTitle = (
        <>
            <Typography color="inherit">
                {props.config.GetTitle()}
                <span
                    style={{
                        fontSize: '12px',
                        fontWeight: 'bold',
                        float: 'right',
                        margin: '4px 0px 0px 10px',
                    }}
                >
                    {props.config.GetShortcut()}
                </span>
            </Typography>
            {props.config.GetHint()}
        </>
    );

    const button = (
        <button
            id={
                GlobalVariables.isForTestRun
                    ? `rbnBtn${upperCaseBegin(props.config.Key)}`
                    : undefined
            }
            ref={buttonRef}
            className={classNames}
            disabled={!props.config.Enabled}
            onClick={props.config.Callback}
        >
            {!textOnly && props.config.GetIcon()}
            {!iconOnly && <span>{props.config.GetTitle()}</span>}
        </button>
    );

    return (
        <StyledTooltip
            key={props.config.GetUniqueKey()}
            title={tooltipTitle}
            PopperProps={{
                anchorEl: {
                    getBoundingClientRect: () => {
                        return new DOMRect(
                            buttonRef.current !== null
                                ? buttonRef.current.getBoundingClientRect().x + 50
                                : 0,
                            155,
                            0,
                            0,
                        );
                    },
                },
            }}
        >
            {!props.config.Enabled ? <span>{button}</span> : button}
        </StyledTooltip>
    );
};
